import styleFile from './AvailAccordion.js';
import RichText from '@synergycms_core/components/generic/RichText';
import Price from '@synergycms_core/components/generic/Price';
import Icon from '@synergycms_core/components/generic/Icon';
import React from 'react';
import { compose, mergeDeepRight } from 'ramda';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import { Image, Button } from '@synergycms_core/components/generic/';
import {concatChildAgeSymbol} from '../../../../utils'

const ChildsNumber = props =>
  props.childs > 0 && (
    <span>
      <RichText
        text={props.childs.toString()}
        icon={{ content: '', innerStyle: ['gold', 'childIcon'] }}
        innerStyle={['roboto16BlackModified']}
      />
      <RichText
        text={'_%niño%_'}
        innerStyle={
          props.segmentFilled && props.theme.deviceType === 'MOBIL' ? ['hideEdit'] : ['roboto16Black', 'child']
        }
        quantity={props.childs}
        translate={true}
      />
      <RichText
        text={concatChildAgeSymbol({childsInfo:props.childsInfo})}
        innerStyle={
          props.segmentFilled && props.theme.deviceType === 'MOBIL' ? ['hideEdit'] : ['roboto16Black', 'child']
        }


      />
    </span>
  );

const AvailAccordionHeader = class AvailAccordionHeader extends React.Component {
  static displayName = 'AvailAccordionHeader';
  constructor(props) {
    super(props);

    this.state = {
      showTooltipHelp: props.config.showHeader || (props.config.totalSegments > 1 && !props.config.segmentFilled)
    };
  }

  closeTooltipHelp = () => {
    this.setState(state =>
      mergeDeepRight(state, {
        showTooltipHelp: false
      })
    );
  };

  componentWillUnmount = () => {
    clearTimeout(this.timeoutTooltip);
  };

  render() {
    const { config, theme } = this.props;

    if (this.state.showTooltipHelp && config.activeSegment) {
      this.timeoutTooltip = setTimeout(() => {
        this.closeTooltipHelp();
      }, 3000);
    }
    const { classes } = theme.styles;
    return (
      <div>
        {this.state.showTooltipHelp && config.activeSegment && (
          <div className={classes.tooltipHelpContainer}>
            <div className={classes.tooltipHelp} onClick={this.closeTooltipHelp}>
              <div className={classes.tooltipHelpCloseContainer}>
                <div className={classes.tooltipHelpClose}>
                  <Button onClick={this.closeTooltipHelp} ariaLabel={'_%seleccionar habitación%_'} translate={true}>
                    <Image unicodeContent={'e020'} innerStyle={['size10']} />
                  </Button>
                </div>
              </div>
              <RichText
                text={'_%seleccionar habitación%_'}
                translate={true}
                ucFirst={true}
                innerStyle={['roboto13Black']}
              />{' '}
              <RichText text={config.segment.toString()} innerStyle={['roboto13Black']} />
            </div>
          </div>
        )}
        <div className={!config.showHeader && config.totalSegments === 1 && !config.segmentFilled ? classes.hideEdit : classes.header}>
          <div className={classes.heading}>
            <div className={classes.headingPack}>
              <RichText
                text={config.segment + '/'}
                innerStyle={config.segmentFilled ? ['roboto32Black', 'white'] : ['roboto32Black']}
              />
              <RichText
                text={config.totalSegments}
                innerStyle={config.segmentFilled ? ['roboto18Black', 'white'] : ['roboto18Black']}
              />
            </div>
            <RichText
              text={'¡ok!'}
              innerStyle={config.segmentFilled ? ['uppercase', 'roboto16White', 'normal'] : ['hide']}
            />
          </div>
          <div className={classes.content}>
            <RichText
              text={config.segmentFilled ? config.roomSelected : '_%seleccionar habitación%_'}
              innerStyle={['roboto24BoldBlack', 'titleRoom']}
              translate={true}
              ucFirst={true}
              icon={
                this.props.theme.deviceType === 'DESK' && {
                  unicodeContent: ['E14D'],
                  innerStyle: [classes.bedIcon, 'mainColor']
                }
              }
            />{' '}
            <RichText
              text={config.segmentFilled ? '' : ' ' + config.segment}
              innerStyle={['roboto24BoldBlack', 'numberRoom']}
            />
            {this.props.theme.deviceType === 'DESK' && (
              <RichText
                text={'_%sin habitación seleccionada%_'}
                innerStyle={config.segmentFilled ? ['hide'] : ['roboto16SoftGray', 'selecRoom']}
                translate={true}
                ucFirst={true}
                icon={{
                  unicodeContent: ['E150'],
                  innerStyle: [classes.warning]
                }}
              />
            )}
            {this.props.theme.deviceType === 'DESK' && (
              <RichText
                text={'_%seleccionada%_'}
                icon={{ unicodeContent: 'e046', innerStyle: ['size11', 'bold'] }}
                innerStyle={config.segmentFilled ? ['roboto16Black', 'green', 'selectedText'] : ['hide']}
                translate={true}
                ucFirst={true}
              />
            )}
            {this.props.theme.deviceType === 'DESK' && (
              <RichText
                text={config.segmentFilled ? config.boardSelected : ''}
                innerStyle={config.segmentFilled ? ['roboto13Black', 'subtextTitle'] : ['hide']}
              />
            )}
            <div>
              <RichText
                text={config.adults.toString()}
                icon={{ content: '', innerStyle: ['gold', 'adultIcon'] }}
                innerStyle={['roboto16BlackModified']}
              />
              <RichText
                text={'_%adulto%_'}
                translate={true}
                quantity={config.adults}
                innerStyle={
                  config.segmentFilled && this.props.theme.deviceType === 'MOBIL'
                    ? ['hideEdit']
                    : ['roboto16Black', 'adult']
                }
              />
              <ChildsNumber childsInfo={config.childsInfo} segmentFilled={config.segmentFilled} childs={config.childs+config.babies} theme={this.props.theme} />
              <Price
                amount={config.segmentAmount}
                innerStyle={config.segmentFilled ? ['monoHotelPrice', 'textMobile'] : ['hide']}
              />
            </div>
          </div>
          <div className={classes.options}>
            <div>
              <Button
                innerStyle={config.segmentFilled ? [classes.hide] : [classes.hideEdit]}
                richText={
                  this.props.theme.deviceType === 'DESK' && {
                    text: '_%editar%_',
                    innerStyle: ['roboto16BoldGold', 'editTitle'],
                    translate: true
                  }
                }
                rightIcon={{
                  content: '',
                  innerStyle: ['editIcon', 'gold']
                }}
                onClick={config.onEditSegment}
              />
            </div>
            {config.totalSegments > 1 && (
              <div className={classes.optionsDelete}>
                <Button onClick={config.onDeleteSegmentClick} ariaLabel={'_%eliminar%_'} translate={true}>
                  <Icon content={''} innerStyle={['gold', 'deleteIcon']} />
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
};

export default compose(
  PropertyManager([
    'totalSegments',
    'segment',
    'segmentFilled',
    'roomSelected',
    'boardSelected',
    'adults',
    'childs',
    'babies',
    'childsInfo',
    'segmentAmount',
    'activeSegment',
    'showHeader',
    'onEditSegment',
    'onDeleteSegmentClick'
  ]),
  withThemeJSS({ styleFile, index: 200, link: true, displayName: 'AvailAccordion' })
)(AvailAccordionHeader);
